import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    global
} from '@/store/module/global'
import {
    stored
} from "@/store/module/stored";

const store = new Vuex.Store({
    modules: {
        global,
        stored
    }
})

export default store
